import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../reducers/Theme';
import { useTheme } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from 'Common/components/Atoms/IconButton';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { faAdjust } from '@fortawesome/pro-solid-svg-icons';
import {
  appThemeSelector,
  isThemeSelectorMenuOpen,
} from '../../selectors/Theme';

const ThemeSelector = (): JSX.Element => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const anchorRef = React.useRef<HTMLButtonElement>();
  const dispatch = useDispatch();
  const isThemeMenuOpen = useSelector(isThemeSelectorMenuOpen);
  const currentTheme = useSelector(appThemeSelector);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(actions.setIsOpenThemeSelector(true));
    setAnchorEl(e.currentTarget);
  };
  return (
    <>
      <IconButton ref={anchorRef} onClick={handleClick} mr={1}>
        <FontIcon icon={faAdjust} size="xs" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isThemeMenuOpen}
        onClose={() => dispatch(actions.setIsOpenThemeSelector(false))}
        onClick={() => dispatch(actions.setIsOpenThemeSelector(false))}
        anchorOrigin={{
          vertical: 42,
          horizontal: -85,
        }}
        MenuListProps={{
          style: {
            padding: 0,
          },
        }}
      >
        <MenuList
          variant="selectedMenu"
          sx={{
            paddingY: 0,
            width: 120,
            '&& .Mui-selected:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <MenuItem disabled>Mode</MenuItem>
          <MenuItem
            selected={currentTheme === 'original'}
            onClick={() => dispatch(actions.setAppTheme('original'))}
          >
            Light
          </MenuItem>
          <MenuItem
            selected={currentTheme === 'dark'}
            onClick={() => dispatch(actions.setAppTheme('dark'))}
          >
            Dark
          </MenuItem>
          <MenuItem
            selected={currentTheme === ''}
            onClick={() => dispatch(actions.setAppTheme(''))}
          >
            Auto
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};

export default ThemeSelector;
